import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  private currentRouteSubject = new BehaviorSubject<string>('');
  public currentRoute$ = this.currentRouteSubject.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const formattedRoute = event.urlAfterRedirects.startsWith('/')
        ? event.urlAfterRedirects.substring(1)
        : event.urlAfterRedirects;
      this.currentRouteSubject.next(formattedRoute);
    });
  }
}

